import { setIn } from "final-form";
import * as yup from "yup";

export interface Values extends Record<string, unknown> {
  name: string;
  submissionType: string;
  dueDate: string;
  lockedDate: string;
  overdueSetting: string;
  active: boolean;
}

export const validationSchema = yup.object({
  name: yup.string().required("A submission peirod name is required"),
  submissionType: yup.string().required("A submission type is required."),
  dueDate: yup
  .date()
  .transform((value, originalValue) => (originalValue === "" ? null : value))
  .required("Due Date is required.")
  .when(["lockedDate", "$initialDueDate"], ([lockedDate, initialDueDate], schema) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const initialDueDateIsPast = initialDueDate && new Date(initialDueDate) < today;

    let result = schema;

    if (!initialDueDateIsPast) {
      result = result.min(today, "Due Date cannot be in the past.");
    }

    if (lockedDate) {
      result = result.max(lockedDate, "Due Date needs to be before Close Date.");
    }

    return result;
  }),
    lockedDate: yup
    .date()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .nullable()
    .when(["$isEditMode", "$initialLockedDate"], ([isEditMode, initialLockedDate], schema) => {
      const today = new Date();
      today.setHours(0, 0, 0, 0); // remove time for accurate comparison

      if (!isEditMode) {
        return schema.min(today, "Close Date cannot be in the past");
      }

      const initialDate = new Date(initialLockedDate);
      initialDate.setHours(0, 0, 0, 0);

      const isInitialPast = initialLockedDate && initialDate < today;

      return isInitialPast
        ? schema // allow editing if original is in the past
        : schema.min(today, "Close Date cannot be in the past");
    }),
  overdueSetting: yup.string().required("An overdue setting is required."),
  active: yup.boolean(),
});

export const validateFormValues = (schema: any, context: Record<string, any> = {}) => async (values: Values) => {
  if (typeof schema === "function") {
    schema = schema();
  }
  try {
    await schema.validateSync(values, { abortEarly: false, context });
  } catch (err: any) {
    const errors = err.inner.reduce((formError: any, innerError: any) => {
      return setIn(formError, innerError.path, innerError.message);
    }, {});

    return errors;
  }
};
